<template>
  <div>
    <img class="mb-4" src="./../assets/logo.png" alt width="40%" height="100%">
    <form class="form-signin" @submit="formSubmit">
      <h1 class="h3 mb-3 font-weight-normal">Lag nytt passord</h1>
      <label for="password" class="sr-only">Passord</label>
      <input
        v-model="password"
        type="password"
        id="password"
        class="form-control"
        placeholder="Passord"
        required
        autofocus
      >
      <label for="repeatPassword" class="sr-only">Gjenta passord</label>
      <input
        v-model="repeatPassword"
        type="password"
        id="repeatPassword"
        class="form-control"
        placeholder="Gjenta passord"
        required
      >

      <button class="btn btn-lg btn-primary btn-block mt-3" type="submit">Send</button>
      <a href="https://booking.pixxip.no/login" class="redirect-url">booking.pixxip.no/login</a>
      <p class="mt-3 mb-3 text-muted">&copy;2019</p>
    </form>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "ChangePassword",
  data: function() {
    return {
      error: "",
      password: "",
      repeatPassword: ""
    };
  },
  methods: {
    formSubmit(e) {
      e.preventDefault();
      let currentObj = this;

      this.axios
        .post("https://service.pixxip.no/api/resetPassword", {
          password: this.password,
          repeatPassword: this.repeatPassword,
          token: this.$route.query.token
        })
        .then(function(response) {

          setTimeout(function(){
            window.location.href = 'https://booking.pixxip.no/login';
          }, 5000);

          if (window.confirm("Passordet ditt er oppdatert. Du blir automatisk sendt videre til innlogging i løp av 5 sekunder. \nhttps://booking.pixxip.no/login")) {
            window.location.href='https://booking.pixxip.no/login';
          };
          
          
        })
        .catch(function(err) {

          if (err.response.status === 400) {
            alert(err.response.data["error"]);
          }
          if (err.response.status === 500) {
            alert("Internal error, try later");
          }

        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}

html,
body {
  height: 100%;
}

body {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
}

h1 {
  color: #7a7a7a;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.redirect-url {
  color: grey;
  font-size: 80%;
}

.redirect-url:hover {
  color: grey; 
}

</style>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue